export enum PagePercentage {
  DUW_QUESTIONAIRE = 46.62,
  DUW_ASSESSMENT = 59.94,

  // TARIFF OPTIONS (11 [constant flow] - 12 [decreasing flow] pages)
  REQUEST_OFFER_DIVERGING_INSURED_PERSON_PAGE = 0,
  LIVING_CONDITIONS_BIRTHDATE = 3.33,
  NEED_PAGE = 6.66,
  DECREASING_SUM_INSURED = 9.99,
  DECREASING_YEARS_TERM = 13.32,
  CONSTANT_SUM_INSURED = 16.65,
  CONSTANT_YEARS_TERM = 19.98,
  DECREASING_INSURANCE_END_SUM = 23.23,
  LIVING_CONDITIONS_EMPLOYMENT = 26.64,
  LIVING_CONDITIONS_SMOKER = 29.97,
  LIVING_CONDITIONS_INCEPTION_DATE = 33.33,

  // CONTRIBUTIONS (2 pages)
  FEE_BEFORE_DUW_PAGE = 36.63,
  DUW_DISCLOSURE_PAGE = 39.96,

  LIVING_CONDITIONS_HEIGHT_WEIGHT = 43.29,
  LIVING_CONDITIONS_BIKER = 46.62,

  // DUW (17 pages)
  DUW_QUESTIONNAIRE_PAGE = 53.28,

  // RISK SURCHARGES (1 page)
  DUW_ASSESSMENT_PAGE = 59.94,

  // PDS (1 page)
  PERSONAL_DATA_PAGE = 63.27,

  // SUBSCRIPTIONS (1 page)
  SUBSCRIPTIONS = 66.66,

  // LEGAL QUESIONS (9 pages)
  LEGAL_QUESTIONS_MONEY_LAUNDERING_PAGE = 70,
  LEGAL_QUESTIONS_PURPOSE_LOAN_PROTECTION_PAGE = 73,
  LEGAL_QUESTIONS_CONSENT_TO_DATA_PROCESSING_PAGE = 76,
  LEGAL_QUESTIONS_CONSENT_TO_RELEASE_OF_PRIVATE_DATA_PAGE = 80,
  LEGAL_QUESTIONS_SUMMARY_PAGE = 83,
  LEGAL_QUESTIONS_CONSENT_TO_CREDIT_CHECK = 86,
  LEGAL_QUESTIONS_IDD_DOWNLOAD_PDF_PAGE = 90,
  LEGAL_QUESTIONS_POS_AG_SIGNATURE_PAGE = 95,
  LEGAL_QUESTIONS_DUU_DOWNLOAD_PDF_PAGE = 100,
}
